/* THE YARN R6: progressive enhancement only. No API calls, storage or commerce writes. */
(() => {
  'use strict';
  if (window.__yarnR51) return;
  window.__yarnR51 = true;
  let dispose = () => {};
  const pieces = Object.freeze({cap: 'A-Frame Cap', tee: 'Heavyweight Tee', hoodie: 'Heavyweight Hoodie'});
  const make = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  function start() {
    dispose();
    const life = new AbortController();
    const cleanups = [];
    const listen = (node, name, fn, options = {}) => node?.addEventListener(name, fn, {...options, signal: life.signal});
    dispose = () => { life.abort(); cleanups.forEach(fn => fn()); };
    const root = document.getElementById('yarn-r5');
    const galleryUpdates = [];
    const menus = [...document.querySelectorAll('.r5-menu')];
    const nativeToggle = document.querySelector('[data-yarn-menu]');
    const nativeMenu = document.querySelector('[data-yarn-mobile-nav]');
    const closeMenus = (restoreFocus = false) => {
      menus.forEach(menu => {
        if (!menu.open) return;
        menu.open = false;
        if (restoreFocus) menu.querySelector('summary')?.focus({preventScroll: true});
      });
      if (nativeToggle?.getAttribute('aria-expanded') === 'true') {
        nativeToggle.setAttribute('aria-expanded', 'false');
        if (nativeMenu) nativeMenu.hidden = true;
        document.body.classList.remove('yarn-menu-open');
        if (restoreFocus) nativeToggle.focus({preventScroll: true});
      }
    };
    listen(document, 'keydown', event => { if (event.key === 'Escape') closeMenus(true); });
    listen(document, 'click', event => {
      if (!(event.target instanceof Element)) return;
      const link = event.target.closest('a');
      if (link?.closest('.r5-menu, [data-yarn-mobile-nav]')) closeMenus();
      if (!event.target.closest('.r5-menu, [data-yarn-menu], [data-yarn-mobile-nav]')) closeMenus();
    });
    const desktop = matchMedia('(min-width: 1181px)');
    listen(desktop, 'change', () => { if (desktop.matches) closeMenus(); });

    if (root) {
      root.querySelectorAll('.r5-product-page').forEach(page => {
        const name = pieces[page.id];
        if (!name) return;
        page.querySelectorAll('.r5-product-enquiry').forEach(link => {
          const url = new URL(link.getAttribute('href'), location.href);
          if (url.origin !== location.origin) return;
          url.searchParams.set('piece', page.id);
          url.hash = 'YarnContactForm';
          link.setAttribute('href', url.pathname + url.search + url.hash);
        });
        const scroller = page.querySelector('.r5-gallery-scroll');
        if (!scroller) return;
        const frames = [...scroller.querySelectorAll('.r5-gallery-frame')];
        if (frames.length < 2) return;
        const id = `YarnViews-${page.id}`;
        scroller.id = id;
        scroller.setAttribute('role', 'region');
        scroller.setAttribute('aria-roledescription', 'carousel');
        scroller.setAttribute('aria-label', `${name} concept views. Use left and right arrow keys to browse.`);
        const controls = make('div', 'yarn-r51-gallery-controls');
        const toolbar = make('div', 'yarn-r51-gallery-toolbar');
        const previous = make('button', '', '←');
        const next = make('button', '', '→');
        const status = make('span', 'yarn-r51-gallery-status');
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        status.setAttribute('aria-atomic', 'true');
        [[previous, 'Previous'], [next, 'Next']].forEach(([button, label]) => {
          button.type = 'button';
          button.setAttribute('aria-label', `${label} ${name} view`);
          button.setAttribute('aria-controls', id);
        });
        toolbar.append(previous, status, next);
        const choices = make('div', 'yarn-r51-gallery-choices');
        choices.setAttribute('role', 'group');
        choices.setAttribute('aria-label', `Choose a ${name} view`);
        controls.append(toolbar, choices);
        scroller.after(controls);
        const guide = scroller.parentElement.querySelector('.r5-gallery-guide > span:first-child');
        const oldGuide = guide?.textContent;
        if (guide) guide.textContent = 'SWIPE OR SELECT A VIEW';
        const labels = frames.map((frame, index) => frame.querySelector('figcaption span:last-child')?.textContent.trim() || `View ${index + 1}`);
        let current = 0;
        let timer;
        const buttons = frames.map((frame, index) => {
          frame.setAttribute('role', 'group');
          frame.setAttribute('aria-roledescription', 'slide');
          frame.setAttribute('aria-label', `${index + 1} of ${frames.length}: ${labels[index]}`);
          const button = make('button', '', labels[index]);
          button.type = 'button';
          button.setAttribute('aria-label', `${name}: ${labels[index]}`);
          button.setAttribute('aria-controls', id);
          choices.append(button);
          return button;
        });
        function update() {
          if (!scroller.clientWidth) return;
          const origin = scroller.getBoundingClientRect().left + scroller.clientLeft;
          current = frames.reduce((best, frame, index) => Math.abs(frame.getBoundingClientRect().left - origin) < Math.abs(frames[best].getBoundingClientRect().left - origin) ? index : best, 0);
          const text = `${String(current + 1).padStart(2, '0')} / ${frames.length} · ${labels[current]}`;
          if (status.textContent !== text) status.textContent = text;
          previous.disabled = current === 0;
          next.disabled = current === frames.length - 1;
          buttons.forEach((button, index) => button.setAttribute('aria-pressed', String(index === current)));
        }
        function go(index) {
          const target = Math.max(0, Math.min(frames.length - 1, index));
          const left = scroller.scrollLeft + frames[target].getBoundingClientRect().left - scroller.getBoundingClientRect().left - scroller.clientLeft;
          scroller.scrollTo({left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
          clearTimeout(timer);
          timer = setTimeout(update, 160);
        }
        buttons.forEach((button, index) => listen(button, 'click', () => go(index)));
        listen(previous, 'click', () => go(current - 1));
        listen(next, 'click', () => go(current + 1));
        listen(scroller, 'scroll', () => { clearTimeout(timer); timer = setTimeout(update, 90); }, {passive: true});
        listen(scroller, 'keydown', event => {
          if (event.target !== scroller) return;
          const targets = {ArrowLeft: current - 1, ArrowRight: current + 1, Home: 0, End: frames.length - 1};
          if (!Object.prototype.hasOwnProperty.call(targets, event.key)) return;
          event.preventDefault(); go(targets[event.key]);
        });
        let observer = null;
        if ('ResizeObserver' in window) {
          observer = new ResizeObserver(update);
          observer.observe(scroller);
        } else {
          listen(window, 'resize', update, {passive: true});
        }
        galleryUpdates.push(update);
        cleanups.push(() => { clearTimeout(timer); observer?.disconnect(); controls.remove(); if (guide) guide.textContent = oldGuide; });
        update();
      });
      function syncRoute(focus = false) {
        if (!root.isConnected || life.signal.aborted) return;
        let hash = location.hash.slice(1);
        if (hash === 'shop') {
          history.replaceState(null, '', location.pathname + location.search + '#collection');
          hash = 'collection';
        }
        const productName = Object.prototype.hasOwnProperty.call(pieces, hash) ? pieces[hash] : '';
        document.title = productName ? `${productName} | THEY SERVE US | THE YARN` : 'THEY SERVE US | THE YARN';
        root.querySelectorAll('.r5-nav a').forEach(link => {
          if (link.hash === '#' + hash || (productName && link.hash === '#collection')) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
        const target = document.getElementById(hash || 'home');
        if (target && (productName || ['home', 'collection', 'craft', 'statement'].includes(hash))) {
          if (focus || hash === 'collection') {
            target.scrollIntoView({block: 'start', behavior: 'auto'});
            if (focus) {
              const heading = target.querySelector('h1,h2') || target;
              if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
              heading.focus({preventScroll: true});
            }
          }
        }
        galleryUpdates.forEach(fn => fn());
      }
      listen(window, 'hashchange', () => requestAnimationFrame(() => syncRoute(true)));
      listen(window, 'pageshow', () => syncRoute(false));
      listen(root, 'click', event => {
        if (!(event.target instanceof Element)) return;
        const link = event.target.closest('a');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        if (link.classList.contains('r5-skip')) {
          event.preventDefault();
          const key = location.hash.slice(1);
          const target = Object.prototype.hasOwnProperty.call(pieces, key) ? document.getElementById(key)?.querySelector('h1') : document.getElementById('r5-main');
          if (target) { target.tabIndex = -1; target.focus(); }
        } else if (link.getAttribute('href') === location.hash) requestAnimationFrame(() => syncRoute(true));
      });
      syncRoute(false);
    }

    const form = document.getElementById('YarnContactForm');
    if (form) {
      const key = new URLSearchParams(location.search).get('piece');
      if (key && Object.prototype.hasOwnProperty.call(pieces, key)) {
        const name = pieces[key];
        const context = make('div', 'yarn-r51-enquiry-context');
        const label = make('p', '', `Enquiry about ${name} · THEY SERVE US / Drop 001`);
        const input = make('input');
        input.type = 'hidden'; input.name = 'contact[Product]'; input.value = `THEY SERVE US / ${name} / Drop 001`;
        const reset = make('button', '', 'Make this a general enquiry');
        reset.type = 'button';
        context.append(label, input, reset);
        form.prepend(context);
        listen(reset, 'click', () => {
          context.remove();
          const url = new URL(location.href); url.searchParams.delete('piece');
          history.replaceState(null, '', url.pathname + url.search + url.hash);
          form.querySelector('input:not([type="hidden"])')?.focus({preventScroll: true});
        });
        cleanups.push(() => context.remove());
      }
      const result = form.querySelector('.yarn-contact-form__status');
      if (result) { result.tabIndex = -1; result.focus({preventScroll: true}); }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('shopify:section:unload', start);
})();
